// @view/document/review/ReviewSectionsVisible.view.tsx

import React from "react";

import type { DocumentReviewViewProps } from "@ps-bridge/contracts/documentReview";
import SectionList from "@view/document/review/SectionList";

type ReviewSectionsVisibleViewProps = Pick<DocumentReviewViewProps, "handleDraft" | "handleRefine" | "handleEdits" | "handleUpload">;

const ReviewSectionsVisibleView: React.FC<ReviewSectionsVisibleViewProps> = ({ handleDraft, handleRefine, handleEdits, handleUpload }) => {
  return (
    <SectionList
      handleDraft={handleDraft}
      handleRefine={handleRefine}
      handleEdits={handleEdits}
      handleUpload={handleUpload}
    />
  );
};

export default ReviewSectionsVisibleView;
